import React from "react"
import PropTypes from "prop-types"
import { InputNumber } from "@infotech/uikit-input"
import Select from "@infotech/uikit-select"
import moment from "moment"
import { Box } from "@infotech/uikit-grid"
import { getTestAttribute } from "src/containers/Plans/Item"
import getAddDateUnit from "./helper"

const durationUnitOptions = [
  { value: `DAY`, label: `дн.` },
  { value: `WEEK`, label: `нед.` },
  { value: `MONTH`, label: `мес.` },
  { value: `YEAR`, label: `г.` },
]

const PlanDurationPicker = ({
  startDateTime,
  change,
  durationType,
  setDurationType,
  durationCount,
  setDurationCount,
  changeEndDateValue,
  isDisabled = false,
}) => (
  <Box flex loose pb="1md">
    <Box loose>
      <div data-testid={getTestAttribute(`plan-duration-count`)}>
        <InputNumber
          name="planDurationCount"
          value={
            durationCount === 86400000
              ? durationCount / 86400000
              : durationCount
          }
          onChange={count => {
            setDurationCount(count)
            const newEndDateValue = moment(startDateTime)
              .add(count, getAddDateUnit(durationType))
              .valueOf()
            change(`endDateTime`, newEndDateValue)
            changeEndDateValue(newEndDateValue - 86400000)
          }}
          style={{ width: `100px` }}
          disabled={isDisabled}
        />
      </div>
    </Box>
    <Box loose pl="2md" w="100px">
      <div data-testid={getTestAttribute(`plan-duration-unit`)}>
        <Select
          placeholder=""
          name="planDurationUnit"
          value={durationType}
          options={durationUnitOptions}
          onChange={({ target: { value: option } }) => {
            setDurationType(option.value)
            const newEndDateValue = moment(startDateTime)
              .add(durationCount, getAddDateUnit(option.value))
              .valueOf()
            change(`endDateTime`, newEndDateValue)
            changeEndDateValue(newEndDateValue - 86400000)
          }}
          isDisabled={isDisabled}
        />
      </div>
    </Box>
  </Box>
)

PlanDurationPicker.propTypes = {
  startDateTime: PropTypes.number.isRequired,
  change: PropTypes.func.isRequired,
  durationType: PropTypes.string.isRequired,
  setDurationType: PropTypes.func.isRequired,
  durationCount: PropTypes.number.isRequired,
  setDurationCount: PropTypes.func.isRequired,
  changeEndDateValue: PropTypes.func.isRequired,
}

export default PlanDurationPicker
